import React, { FunctionComponent } from "react";
import { useNavigate } from "react-router";

import { EditIcon, TrashIcon } from "../common/sidebar/icons";
import { useLimits } from "../../hooks/useLimits";
import FirebaseService from "../../actions/firebase/FirebaseActions";
import { useAuthentication } from "../../hooks/useAuthentication";
import { ContentLayout } from "../common/Layout";
import { Meter } from "../common/Meter";
import { useUserIdParam } from "../../hooks/useUserIdParam";

interface Props {
  isAuthenticated: boolean;
}

const formatCurrency = (amount: number): string => `CHF ${new Intl.NumberFormat("de-CH").format(amount)}`;

const Limits: FunctionComponent<Props> = ({ isAuthenticated }) => {
  const navigate = useNavigate();
  const userId = useUserIdParam();

  const [limits, limitsLoading, limitsError] = useLimits(userId);
  useAuthentication(isAuthenticated);

  if (limitsError) return <p>Fehler beim Laden der Daten</p>;

  return (
    <ContentLayout
      siteTitle={"Spielgruppe Online - Angebot"}
      title={"Angebot"}
      subtitle={`${limits.length} Angebote`}
      isLoading={limitsLoading}
      actions={
        <button type="button" className="btn btn-primary" onClick={() => navigate(`/user/${userId}/limits/create`)}>
          Neues Angebot
        </button>
      }>
      <section className="panel">
        <div className="data-row data-row--head data-row--limit">
          <span>Angebot</span>
          <span>Belegung</span>
          <span className="text-end">Preis</span>
          <span className="text-end">Einnahmen</span>
          <span />
        </div>

        {limits.length === 0 && <div className="panel__body text-muted">Noch keine Angebote erfasst.</div>}

        <div className="data-rows">
          {limits.map((limit) => (
            <div className="data-row data-row--limit" key={limit.id}>
              <div className="data-row__primary">{limit.property}</div>
              <Meter taken={limit.taken || 0} total={limit.limit || 0} />
              <span className="data-row__money">{limit.price ? formatCurrency(limit.price) : "–"}</span>
              <span className={`data-row__money${limit.taken ? "" : " is-zero"}`}>
                {formatCurrency((limit.price || 0) * (limit.taken || 0))}
              </span>
              <div className="data-row__actions">
                <button
                  type="button"
                  title="Bearbeiten"
                  className="btn btn-icon"
                  onClick={() => navigate(`/user/${userId}/limits/${limit.id}`)}>
                  <EditIcon />
                </button>
                <button
                  type="button"
                  title="Löschen"
                  className="btn btn-icon btn-icon-danger"
                  onClick={() => {
                    if (window.confirm("Limitierung wirklich löschen?")) {
                      FirebaseService.deleteLimit(userId, limit.id);
                    }
                  }}>
                  <TrashIcon />
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </ContentLayout>
  );
};

export default Limits;
